/**
 * Audio utilities for user feedback
 */

export function playSuccessSound(): void {
  try {
    const audio = new Audio('/sounds/success.mp3')
    audio.volume = 0.3
    audio.play().catch(() => {
      // Fail silently if audio can't play
    })
  } catch {
    // Fail silently if audio not supported
  }
}

export function playButtonClickSound(): void {
  try {
    const audio = new Audio('/sounds/click.mp3')
    audio.volume = 0.2
    audio.play().catch(() => {
      // Fail silently if audio can't play
    })
  } catch {
    // Fail silently if audio not supported
  }
}

export function celebrateAchievement(): void {
  // Play celebration sound if available
  if ('vibrate' in navigator) {
    navigator.vibrate([100, 50, 100])
  }

  // Could trigger confetti animation or other celebration effects
  document.dispatchEvent(new CustomEvent('achievement-unlocked', {
    detail: { timestamp: Date.now() }
  }))
}
